import React from 'react'
import Button from '../../Button'
import Card from '../../Card'
import CardContent from '../../CardContent'
import CardIcon from '../../CardIcon'
import CardTitle, {CardSubTitle} from '../../CardTitle'
import Spacer from '../../Spacer'

interface WalletCardProps {
    icon: React.ReactNode
    onConnect: () => void
    title: string,
    subTitle:string
}

const WalletCard: React.FC<WalletCardProps> = ({icon, onConnect, title,subTitle}) => (
    <Card>
        <CardContent>
            <div onClick={onConnect}>
                <CardIcon>{icon}</CardIcon>
                <CardTitle text={title}/>
                <CardSubTitle text={subTitle}/>
            </div>
        </CardContent>
    </Card>
);

export default WalletCard
